import uuid from 'react-uuid'


export const mockDataTabList = [
    {
        tab_id: uuid(),
        custom_name: 'Location',
        system_name: 'tab0',
        custom_position: 0,
        tab_type: '9 Columns',
    },
    {
        tab_id: uuid(),
        custom_name: 'People',
        system_name: 'tab1',
        custom_position: 1,
        tab_type: '9 Columns',
    },
    {
        tab_id: uuid(),
        custom_name: 'Services',
        system_name: 'tab2',
        custom_position: 2,
        tab_type: '9 Columns',
    },
    {
        tab_id: uuid(),
        custom_name: 'Account',
        system_name: 'tab3',
        custom_position: 3,
        tab_type: '9 Columns',
    },
    {
        tab_id: uuid(),
        custom_name: 'Dashboard',
        system_name: 'tab4',
        custom_position: 4,
        tab_type: '9 Columns',
    },
    {
        tab_id: uuid(),
        custom_name: 'Dashboard Data',
        system_name: 'tab5',
        custom_position: 5,
        tab_type: '9 Columns',
    },
]

export const mockDataTab0View = [
    {
        cardId: uuid(),
        label: 'Geo Location',
        position: 0,
        type: 'Data List',
        cardData: [
            {
                fieldId: uuid(),
                label: 'Address',
                position: 0,
                type: 'Text',
                isMandatory: true,
                fieldData: '288 First Street East, Suite 200'
            },
            {
                fieldId: uuid(),
                label: 'City',
                position: 1,
                type: 'Text',
                isMandatory: true,
                fieldData: 'North Vancouver'
            },
            {
                fieldId: uuid(),
                label: 'Province',
                position: 2,
                type: 'province',
                isMandatory: true,
                fieldData: 'BC'
            },
            {
                fieldId: uuid(),
                label: 'Country',
                position: 4,
                type: 'country',
                isMandatory: true,
                fieldData: 'Canada'
            },
            {
                fieldId: uuid(),
                label: 'Postal Code',
                position: 3,
                type: 'Text',
                isMandatory: true,
                fieldData: 'V7L 1B3'
            },
        ]
    },
    {
        cardId: uuid(),
        label: 'Geo Context',
        position: 1,
        type: 'Data List',
        cardData: [
            {
                fieldId: uuid(),
                label: 'Industry Type',
                position: 0,
                type: 'industry type',
                isMandatory: true,
                fieldData: 'Aerospace'
            },
            {
                fieldId: uuid(),
                label: 'Building Type',
                position: 1,
                type: 'building type',
                isMandatory: true,
                fieldData: 'Commercial'
            },
            {
                fieldId: uuid(),
                label: 'Zone',
                position: 2,
                type: 'Text',
                isMandatory: false,
                fieldData: 'Zone V2'
            },
            {
                fieldId: uuid(),
                label: 'Building Population',
                position: 4,
                type: 'Number',
                isMandatory: false,
                fieldData: '1234'
            },
            {
                fieldId: uuid(),
                label: 'Location Size',
                position: 3,
                type: 'Number',
                isMandatory: false,
                fieldData: '1244'
            },
        ]
    },
    {
        cardId: uuid(),
        label: '',
        position: 2,
        type: 'Image Slider',
        cardData: [
            {
                fieldId: uuid(),
                label: '',
                position: 0,
                type: 'Text',
                isMandatory: false,
                fieldData: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcReU2QIXDT2Ygs7sQPSPkUC4IxW9vb3aLWsRw&usqp=CAU'
            },
            {
                fieldId: uuid(),
                label: '',
                position: 1,
                type: 'Text',
                isMandatory: false,
                fieldData: 'https://thefinancialbrand.com/wp-content/uploads/2011/01/rbc_interior2.jpg'
            },
            {
                fieldId: uuid(),
                label: '',
                position: 2,
                type: 'Text',
                isMandatory: false,
                fieldData: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRw7-6fDM4svnfF0-qOivXROmkd-U3bLALDIQ&usqp=CAU'
            },
        ]
    },
    {
        cardId: uuid(),
        label: 'Commercial Reference',
        position: 3,
        type: 'Data List',
        cardData: [
            {
                fieldId: uuid(),
                label: 'Building ID',
                position: 0,
                type: 'Text',
                isMandatory: true,
                fieldData: 'BUI142356'
            },
            {
                fieldId: uuid(),
                label: 'Building Name',
                position: 1,
                type: 'Text',
                isMandatory: true,
                fieldData: 'RBC'
            },
            {
                fieldId: uuid(),
                label: 'Description',
                position: 2,
                type: 'Text',
                isMandatory: false,
                fieldData: 'Royal Bank of Canada is a Canadian multinational financial services company and the largest bank in Canada by market capitalization. '
            },
            {
                fieldId: uuid(),
                label: 'Transit ID',
                position: 3,
                type: 'Text',
                isMandatory: false,
                fieldData: 'TR4332'
            },
        ]
    },
    {
        cardId: uuid(),
        label: 'Business Compliance',
        position: 4,
        type: 'Data List',
        cardData: [
            {
                fieldId: uuid(),
                label: 'License',
                position: 0,
                type: 'Link',
                isMandatory: false,
                fieldData: 'https://docs.google.com/document/d/1ILEJlaQ2cksNnsFn1NOerLXKpNU_3XnpIR59dUo40Lo/edit?usp=sharing'
            },
            {
                fieldId: uuid(),
                label: 'Report',
                position: 1,
                type: 'Link',
                isMandatory: false,
                fieldData: 'https://docs.google.com/document/d/1ILEJlaQ2cksNnsFn1NOerLXKpNU_3XnpIR59dUo40Lo/edit?usp=sharing'
            },
            {
                fieldId: uuid(),
                label: 'Accounts',
                position: 2,
                type: 'Text',
                isMandatory: false,
                fieldData: 'RBC'
            },
            {
                fieldId: uuid(),
                label: 'Security',
                position: 3,
                type: 'Text',
                isMandatory: false,
                fieldData: '2234'
            },
        ]
    },
    {
        cardId: uuid(),
        label: 'Facility Data',
        position: 5,
        type: 'Data List',
        cardData: [
            {
                fieldId: uuid(),
                label: 'Cleaning hours',
                position: 0,
                type: 'Text',
                isMandatory: false,
                fieldData: '7pm to 9pm'
            },
            {
                fieldId: uuid(),
                label: 'Days of Service',
                position: 1,
                type: 'Text',
                isMandatory: false,
                fieldData: 'Mon, Wed, Fri'
            },
            {
                fieldId: uuid(),
                label: 'Size (Sq. ft)',
                position: 2,
                type: 'Number',
                isMandatory: true,
                fieldData: '123333'
            },
            {
                fieldId: uuid(),
                label: 'Access/Security Code',
                position: 3,
                type: 'Text',
                isMandatory: false,
                fieldData: '1243'
            },
            {
                fieldId: uuid(),
                label: 'Dimension',
                position: 4,
                type: 'Text',
                isMandatory: false,
                fieldData: ''
            },
            {
                fieldId: uuid(),
                label: 'Layout',
                position: 5,
                type: 'Link',
                isMandatory: false,
                fieldData: 'https://docs.google.com/document/d/1ILEJlaQ2cksNnsFn1NOerLXKpNU_3XnpIR59dUo40Lo/edit?usp=sharing'
            },
        ]
    },

    {
        cardId: uuid(),
        label: 'F&M Compliance',
        position: 6,
        type: 'Data List',
        cardData: [
            {
                fieldId: uuid(),
                label: 'Last Inspection Date',
                position: 0,
                type: 'Date',
                isMandatory: false,
                fieldData: 'Jan 01, 2022'
            },
            {
                fieldId: uuid(),
                label: 'Quality assurance report',
                position: 1,
                type: 'Link',
                isMandatory: false,
                fieldData: 'https://docs.google.com/document/d/1ILEJlaQ2cksNnsFn1NOerLXKpNU_3XnpIR59dUo40Lo/edit?usp=sharing'
            },
            {
                fieldId: uuid(),
                label: 'Fire extinguisher report',
                position: 2,
                type: 'Link',
                isMandatory: false,
                fieldData: 'https://docs.google.com/document/d/1ILEJlaQ2cksNnsFn1NOerLXKpNU_3XnpIR59dUo40Lo/edit?usp=sharing'
            },
            {
                fieldId: uuid(),
                label: 'Maintenance',
                position: 3,
                type: 'Link',
                isMandatory: false,
                fieldData: 'https://docs.google.com/document/d/1ILEJlaQ2cksNnsFn1NOerLXKpNU_3XnpIR59dUo40Lo/edit?usp=sharing'
            },
        ]
    },
    {
        cardId: uuid(),
        label: 'Note',
        position: 7,
        type: 'Note',
        cardData: [
            {
                fieldId: uuid(),
                label: 'Notes',
                position: 0,
                type: 'Text',
                isMandatory: false,
                fieldData: 'This is a test description'
            },
        ]
    },
]

export const mockDataTab1View = [
    {
        cardId: uuid(),
        label: 'Staff',
        position: 0,
        type: 'Contact List',
        cardData: []
    },
    {
        cardId: uuid(),
        label: 'Manager',
        position: 1,
        type: 'Contact List',
        cardData: []
    },
    {
        cardId: uuid(),
        label: 'Contractor',
        position: 2,
        type: 'Contact List',
        cardData: []
    },
    {
        cardId: uuid(),
        label: 'Client',
        position: 3,
        type: 'Contact List',
        cardData: []
    },
    {
        cardId: uuid(),
        label: 'Admin',
        position: 4,
        type: 'Contact List',
        cardData: []
    },
    {
        cardId: uuid(),
        label: '',
        position: 5,
        type: 'Contact Detail',
        cardData: [
            {
                fieldId: uuid(),
                label: 'Phone Number',
                position: 0,
                type: 'Text',
                isMandatory: true,
                isHidden: false,
                isArchived: false,
            },
            {
                fieldId: uuid(),
                label: 'Email Address',
                position: 1,
                type: 'Text',
                isMandatory: true,
                isHidden: false,
                isArchived: false,
            },
            {
                fieldId: uuid(),
                label: 'Address',
                position: 2,
                type: 'Text',
                isMandatory: true,
                isHidden: false,
                isArchived: false,
            },
            {
                fieldId: uuid(),
                label: 'ID Number',
                position: 3,
                type: 'Text',
                isMandatory: true,
                isHidden: false,
                isArchived: false,
            },
            {
                fieldId: uuid(),
                label: 'Assigned Date',
                position: 4,
                type: 'Text',
                isMandatory: true,
                isHidden: false,
                isArchived: false,
            },
        ]
    },
    {
        cardId: uuid(),
        cardMetadataId: 3,
        label: '["Personal Compliance", "Effective Date", "Value"]',
        position: 6,
        type: 'Multiple Columns Data List',
        cardData: [
            {
                fieldId: uuid(),
                label: 'Declaration 1',
                position: 0,
                type: 'Text',
                isMandatory: false,
                isHidden: false,
                isArchived: false,
            },
            {
                fieldId: uuid(),
                label: 'Declaration 2',
                position: 1,
                type: 'Text',
                isMandatory: false,
                isHidden: false,
                isArchived: false,
            },
            {
                fieldId: uuid(),
                label: 'Declaration 3',
                position: 2,
                type: 'Text',
                isMandatory: false,
                isHidden: false,
                isArchived: false,
            },
            {
                fieldId: uuid(),
                label: 'Declaration 4',
                position: 3,
                type: 'Text',
                isMandatory: false,
                isHidden: false,
                isArchived: false,
            },
            {
                fieldId: uuid(),
                label: 'Declaration 5',
                position: 4,
                type: 'Text',
                isMandatory: false,
                isHidden: false,
                isArchived: false,
            },
        ]
    },
    {
        cardId: uuid(),
        cardMetadataId: 3,
        label: '["Work Compliance", "Effective Date", "Value"]',
        position: 7,
        type: 'Multiple Columns Data List',
        cardData: [
            {
                fieldId: uuid(),
                label: 'Declaration 1',
                position: 0,
                type: 'Text',
                isMandatory: false,
                isHidden: false,
                isArchived: false,
            },
            {
                fieldId: uuid(),
                label: 'Declaration 2',
                position: 1,
                type: 'Text',
                isMandatory: false,
                isHidden: false,
                isArchived: false,
            },
            {
                fieldId: uuid(),
                label: 'Declaration 3',
                position: 2,
                type: 'Text',
                isMandatory: false,
                isHidden: false,
                isArchived: false,
            },
            {
                fieldId: uuid(),
                label: 'Declaration 4',
                position: 3,
                type: 'Text',
                isMandatory: false,
                isHidden: false,
                isArchived: false,
            },
            {
                fieldId: uuid(),
                label: 'Declaration 5',
                position: 4,
                type: 'Text',
                isMandatory: false,
                isHidden: false,
                isArchived: false,
            },
        ]
    },
    {
        cardId: uuid(),
        cardMetadataId: 3,
        label: '["Note", "Value"]',
        position: 8,
        type: 'Multiple Columns Data List',
        cardData: [
            {
                fieldId: uuid(),
                label: 'Note 1',
                position: 0,
                type: 'Text',
                isMandatory: false,
                isHidden: false,
                isArchived: false,
            },
            {
                fieldId: uuid(),
                label: 'Note 2',
                position: 1,
                type: 'Text',
                isMandatory: true,
                isHidden: false,
                isArchived: false,
            },
        ]
    },
]

export const mockDataTab2View = [
        {
            cardId: uuid(),
            cardMetadataId: 1,
            label: 'Interior',
            position: 0,
            type: 'Service List',
            cardData: []
        },
        {
            cardId: uuid(),
            cardMetadataId: 1,
            label: 'Exterior',
            position: 1,
            type: 'Service List',
            cardData: []
        },
        {
            cardId: uuid(),
            cardMetadataId: 1,
            label: 'Janitorial',
            position: 2,
            type: 'Service List',
            cardData: []
        },
        {
            cardId: uuid(),
            cardMetadataId: 1,
            label: 'Landscaping',
            position: 3,
            type: 'Service List',
            cardData: []
        },
        {
            cardId: uuid(),
            cardMetadataId: 1,
            label: 'Snow Removal',
            position: 4,
            type: 'Service List',
            cardData: []
        },
        {
            cardId: uuid(),
            cardMetadataId: 1,
            label: 'Facility',
            position: 5,
            type: 'Service List',
            cardData: []
        },
        {
            cardId: uuid(),
            cardMetadataId: 1,
            label: 'Security',
            position: 6,
            type: 'Service List',
            cardData: []
        },
        {
            cardId: uuid(),
            cardMetadataId: 2,
            label: '',
            position: 1,
            type: 'Service Detail',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Contract Size',
                    position: 0,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Service Category',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Service Type',
                    position: 2,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Service Level',
                    position: 3,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Cleaning Hours',
                    position: 4,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Days of Service',
                    position: 5,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Scope of Service',
                    position: 6,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Annual periodic requirements',
                    position: 7,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Special Service',
                    position: 8,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
            ]
        },
        {
            cardId: uuid(),
            cardMetadataId: 3,
            label: '["Interior Data", "Value"]',
            position: 2,
            type: 'Multiple Columns Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Declaration 1',
                    position: 0,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 2',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 3',
                    position: 2,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 4',
                    position: 3,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 5',
                    position: 4,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
            ]
        },
        {
            cardId: uuid(),
            cardMetadataId: 4,
            label: '["Special Notes", "Value"]',
            position: 3,
            type: 'Multiple Columns Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Declaration 1',
                    position: 0,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 2',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 3',
                    position: 2,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 4',
                    position: 3,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 5',
                    position: 4,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
            ]
        },
    ]

export const mockDataTab3View = [
    {
        cardId: uuid(),
        label: '',
        position: 0,
        type: 'Account Detail',
        cardData: []
    },
    {
        cardId: uuid(),
        label: 'Conversation History',
        position: 1,
        type: 'Conversation History',
        cardData: [
            {
                fieldId: uuid(),
                label: '',
                position: 0,
                type: 'Text',
                isMandatory: false,
                // TODO It might be a problem when they have many messages in the future because of char limit
                fieldData: '[{"Date": "Feb 10, 2022", "message": "Spoke to John, requested for information"}, {"Date": "Oct 10, 2021", "message": "Follow up on proposal"}]'
            },
        ]
    },
    {
        cardId: uuid(),
        label: 'Location List',
        position: 2,
        type: 'Location List',
        cardData: []
    },
    {
        cardId: uuid(),
        label: 'Lifecycle',
        position: 3,
        type: 'Note',
        cardData: [
            {
                fieldId: uuid(),
                label: '',
                position: 0,
                type: 'Text',
                isMandatory: false,
                fieldData: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
            },
        ]
    },
]

export const mockDataTab0Layout = {
    data: [
        {
            cardId: uuid(),
            cardMetadataId: 1,
            label: 'Geo Location',
            position: 0,
            type: 'Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Address',
                    position: 0,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'City',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Province',
                    position: 2,
                    type: 'Province',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Country',
                    position: 4,
                    type: 'Country',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Postal Code',
                    position: 3,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 1',
                    position: 5,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 2',
                    position: 6,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 3',
                    position: 7,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 4',
                    position: 8,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 5',
                    position: 9,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
            ]
        },
        {
            cardId: uuid(),
            cardMetadataId: 2,
            label: 'Geo Context',
            position: 1,
            type: 'Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Industry Type',
                    position: 0,
                    type: 'Industry Type',
                    isMandatory: true,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Building Type',
                    position: 1,
                    type: 'Building Type',
                    isMandatory: true,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Zone',
                    position: 2,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Building Population',
                    position: 4,
                    type: 'Number',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Location Size',
                    position: 3,
                    type: 'Number',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 1',
                    position: 5,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 2',
                    position: 6,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 3',
                    position: 7,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 4',
                    position: 8,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 5',
                    position: 9,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
            ]
        },
        {
            cardId: uuid(),
            cardMetadataId: 3,
            label: '',
            position: 2,
            type: 'Image Slider',
            cardData: [
                {
                    fieldId: uuid(),
                    label: '',
                    position: 0,
                    type: 'Text',
                    isMandatory: true,
                    fieldData: 'https://liverangewater.com/wp-content/uploads/2022/06/Amelia-Westshore-555x473.jpg'
                },
                {
                    fieldId: uuid(),
                    label: '',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    fieldData: 'https://marisolatviera.com/wp-content/uploads/2021/04/Marisol-2-Bedroom-5-1-980x630.jpg'
                },
                {
                    fieldId: uuid(),
                    label: '',
                    position: 2,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: 'https://marisolatviera.com/wp-content/uploads/2021/04/Marisol-2-Bedroom-6-1-980x630.jpg'
                },
                {
                    fieldId: uuid(),
                    label: '',
                    position: 3,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: 'https://marisolatviera.com/wp-content/uploads/2021/04/Marisol-2-Bedroom-7-980x630.jpg'
                },
            ]
        },
        {
            cardId: uuid(),
            cardMetadataId: 4,
            label: 'Commercial Reference',
            position: 3,
            type: 'Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Building ID',
                    position: 0,
                    type: 'Text',
                    isMandatory: true,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Building Name',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Description',
                    position: 2,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Transit ID',
                    position: 3,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 1',
                    position: 4,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 2',
                    position: 5,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 3',
                    position: 6,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 4',
                    position: 7,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 5',
                    position: 8,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 6',
                    position: 9,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
            ]
        },
        {
            cardId: uuid(),
            cardMetadataId: 5,
            label: 'Business Compliance',
            position: 4,
            type: 'Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'License',
                    position: 0,
                    type: 'Link',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Report',
                    position: 1,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Accounts',
                    position: 2,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Security',
                    position: 3,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 1',
                    position: 4,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 2',
                    position: 5,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 3',
                    position: 6,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 4',
                    position: 7,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 5',
                    position: 8,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 6',
                    position: 9,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
            ]
        },
        {
            cardId: uuid(),
            cardMetadataId: 6,
            label: 'Facility Data',
            position: 5,
            type: 'Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Cleaning hours',
                    position: 0,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Days of Service',
                    position: 1,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Size (Sq. ft)',
                    position: 2,
                    type: 'Number',
                    isMandatory: true,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Access/Security Code',
                    position: 3,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Dimension',
                    position: 4,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Layout',
                    position: 5,
                    type: 'Link',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 1',
                    position: 6,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 2',
                    position: 7,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 3',
                    position: 8,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 4',
                    position: 9,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
            ]
        },
        {
            cardId: uuid(),
            cardMetadataId: 7,
            label: 'F&M Compliance',
            position: 6,
            type: 'Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Last Inspection Date',
                    position: 0,
                    type: 'Date',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Quality assurance report',
                    position: 1,
                    type: 'Link',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Fire extinguisher report',
                    position: 2,
                    type: 'Link',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Maintenance',
                    position: 3,
                    type: 'Link',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 1',
                    position: 4,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 2',
                    position: 5,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 3',
                    position: 6,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 4',
                    position: 7,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 5',
                    position: 8,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 6',
                    position: 9,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
            ]
        },
        {
            cardId: uuid(),
            cardMetadataId: 8,
            label: 'Note',
            position: 7,
            type: 'Note',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Notes',
                    position: 0,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
            ]
        },
    ],
    defaultData: [
        {
            cardMetadataId: 1,
            label: 'Geo Location',
            position: 0,
            type: 'Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Address',
                    position: 0,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'City',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Province',
                    position: 2,
                    type: 'province',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Country',
                    position: 4,
                    type: 'country',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Postal Code',
                    position: 3,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 1',
                    position: 5,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 2',
                    position: 6,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 3',
                    position: 7,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 4',
                    position: 8,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 5',
                    position: 9,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
            ]
        },
        {
            cardMetadataId: 2,
            label: 'Geo Context',
            position: 1,
            type: 'Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Industry Type',
                    position: 0,
                    type: 'industry type',
                    isMandatory: true,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Building Type',
                    position: 1,
                    type: 'building type',
                    isMandatory: true,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Zone',
                    position: 2,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Building Population',
                    position: 4,
                    type: 'Number',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Location Size',
                    position: 3,
                    type: 'Number',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 1',
                    position: 5,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 2',
                    position: 6,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 3',
                    position: 7,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 4',
                    position: 8,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 5',
                    position: 9,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
            ]
        },
        {
            cardMetadataId: 3,
            label: '',
            position: 2,
            type: 'Image Slider',
            cardData: [
                {
                    fieldId: uuid(),
                    label: '',
                    position: 0,
                    type: 'Text',
                    isMandatory: true,
                    fieldData: 'https://liverangewater.com/wp-content/uploads/2022/06/Amelia-Westshore-555x473.jpg'
                },
                {
                    fieldId: uuid(),
                    label: '',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    fieldData: 'https://marisolatviera.com/wp-content/uploads/2021/04/Marisol-2-Bedroom-5-1-980x630.jpg'
                },
                {
                    fieldId: uuid(),
                    label: '',
                    position: 2,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: 'https://marisolatviera.com/wp-content/uploads/2021/04/Marisol-2-Bedroom-6-1-980x630.jpg'
                },
                {
                    fieldId: uuid(),
                    label: '',
                    position: 3,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: 'https://marisolatviera.com/wp-content/uploads/2021/04/Marisol-2-Bedroom-7-980x630.jpg'
                },
            ]
        },
        {
            cardMetadataId: 4,
            label: 'Commercial Reference',
            position: 3,
            type: 'Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Building ID',
                    position: 0,
                    type: 'Text',
                    isMandatory: true,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Building Name',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Description',
                    position: 2,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Transit ID',
                    position: 3,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 1',
                    position: 4,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 2',
                    position: 5,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 3',
                    position: 6,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 4',
                    position: 7,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 5',
                    position: 8,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 6',
                    position: 9,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
            ]
        },
        {
            cardMetadataId: 5,
            label: 'Business Compliance',
            position: 4,
            type: 'Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'License',
                    position: 0,
                    type: 'Link',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Report',
                    position: 1,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Accounts',
                    position: 2,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Security',
                    position: 3,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 1',
                    position: 4,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 2',
                    position: 5,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 3',
                    position: 6,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 4',
                    position: 7,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 5',
                    position: 8,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 6',
                    position: 9,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
            ]
        },
        {
            cardMetadataId: 6,
            label: 'Facility Data',
            position: 5,
            type: 'Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Cleaning hours',
                    position: 0,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Days of Service',
                    position: 1,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Size (Sq. ft)',
                    position: 2,
                    type: 'Number',
                    isMandatory: true,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Access/Security Code',
                    position: 3,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Dimension',
                    position: 4,
                    type: 'Text',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Layout',
                    position: 5,
                    type: 'Link',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 1',
                    position: 6,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 2',
                    position: 7,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 3',
                    position: 8,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 4',
                    position: 9,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
            ]
        },
        {
            cardMetadataId: 7,
            label: 'F&M Compliance',
            position: 6,
            type: 'Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Last Inspection Date',
                    position: 0,
                    type: 'Date',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Quality assurance report',
                    position: 1,
                    type: 'Link',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Fire extinguisher report',
                    position: 2,
                    type: 'Link',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Maintenance',
                    position: 3,
                    type: 'Link',
                    isMandatory: false,
                    fieldData: ''
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 1',
                    position: 4,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 2',
                    position: 5,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 3',
                    position: 6,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 4',
                    position: 7,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 5',
                    position: 8,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
                {
                    fieldId: uuid(),
                    label: 'Custom Field 6',
                    position: 9,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
            ]
        },
        {
            cardMetadataId: 8,
            label: 'Note',
            position: 7,
            type: 'Note',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Notes',
                    position: 0,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: true
                },
            ]
        },
    ],
}

export const mockDataTab1Layout = {
    data: [
        {
            cardId: uuid(),
            label: 'Staff',
            position: 0,
            type: 'Contact List',
            cardData: []
        },
        {
            cardId: uuid(),
            label: 'Manager',
            position: 1,
            type: 'Contact List',
            cardData: []
        },
        {
            cardId: uuid(),
            label: 'Contractor',
            position: 2,
            type: 'Contact List',
            cardData: []
        },
        {
            cardId: uuid(),
            label: 'Client',
            position: 3,
            type: 'Contact List',
            cardData: []
        },
        {
            cardId: uuid(),
            label: 'Admin',
            position: 4,
            type: 'Contact List',
            cardData: []
        },
        {
            cardId: uuid(),
            label: '',
            position: 5,
            type: 'Contact Detail',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Phone Number',
                    position: 0,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Email Address',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Address',
                    position: 2,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'ID Number',
                    position: 3,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Assigned Date',
                    position: 4,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
            ]
        },
        {
            cardId: uuid(),
            cardMetadataId: 3,
            label: '["Personal Compliance", "Effective Date", "Value"]',
            position: 6,
            type: 'Multiple Columns Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Declaration 1',
                    position: 0,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 2',
                    position: 1,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 3',
                    position: 2,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 4',
                    position: 3,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 5',
                    position: 4,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
            ]
        },
        {
            cardId: uuid(),
            cardMetadataId: 3,
            label: '["Work Compliance", "Effective Date", "Value"]',
            position: 7,
            type: 'Multiple Columns Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Declaration 1',
                    position: 0,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 2',
                    position: 1,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 3',
                    position: 2,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 4',
                    position: 3,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 5',
                    position: 4,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
            ]
        },
        {
            cardId: uuid(),
            cardMetadataId: 3,
            label: '["Note", "Value"]',
            position: 8,
            type: 'Multiple Columns Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Note 1',
                    position: 0,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Note 2',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
            ]
        },
    ],
    defaultData: [
        {
            cardId: uuid(),
            label: '',
            position: 0,
            type: 'Staff',
            cardData: []
        },
        {
            cardId: uuid(),
            label: '',
            position: 1,
            type: 'Manager',
            cardData: []
        },
        {
            cardId: uuid(),
            label: '',
            position: 2,
            type: 'Contractor',
            cardData: []
        },
        {
            cardId: uuid(),
            label: '',
            position: 3,
            type: 'Client',
            cardData: []
        },
        {
            cardId: uuid(),
            label: '',
            position: 4,
            type: 'Admin',
            cardData: []
        },
        {
            cardId: uuid(),
            label: '',
            position: 5,
            type: 'Contact Detail',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Phone Number',
                    position: 0,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Email Address',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Address',
                    position: 2,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'ID Number',
                    position: 3,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Assigned Date',
                    position: 4,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
            ]
        },
        {
            cardId: uuid(),
            cardMetadataId: 3,
            label: '["Personal Compliance", "Effective Date", "Value"]',
            position: 6,
            type: 'Multiple Columns Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Declaration 1',
                    position: 0,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 2',
                    position: 1,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 3',
                    position: 2,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 4',
                    position: 3,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 5',
                    position: 4,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
            ]
        },
        {
            cardId: uuid(),
            cardMetadataId: 3,
            label: '["Work Compliance", "Effective Date", "Value"]',
            position: 7,
            type: 'Multiple Columns Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Declaration 1',
                    position: 0,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 2',
                    position: 1,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 3',
                    position: 2,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 4',
                    position: 3,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 5',
                    position: 4,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
            ]
        },
        {
            cardId: uuid(),
            cardMetadataId: 3,
            label: '["Note", "Value"]',
            position: 8,
            type: 'Multiple Columns Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Note 1',
                    position: 0,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Note 2',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
            ]
        },
    ]
}

export const mockDataTab2Layout = {
    data: [
        {
            cardId: uuid(),
            cardMetadataId: 1,
            label: 'Interior',
            position: 0,
            type: 'Service List',
            cardData: []
        },
        {
            cardId: uuid(),
            cardMetadataId: 1,
            label: 'Exterior',
            position: 1,
            type: 'Service List',
            cardData: []
        },
        {
            cardId: uuid(),
            cardMetadataId: 1,
            label: 'Janitorial',
            position: 2,
            type: 'Service List',
            cardData: []
        },
        {
            cardId: uuid(),
            cardMetadataId: 1,
            label: 'Landscaping',
            position: 3,
            type: 'Service List',
            cardData: []
        },
        {
            cardId: uuid(),
            cardMetadataId: 1,
            label: 'Snow Removal',
            position: 4,
            type: 'Service List',
            cardData: []
        },
        {
            cardId: uuid(),
            cardMetadataId: 1,
            label: 'Facility',
            position: 5,
            type: 'Service List',
            cardData: []
        },
        {
            cardId: uuid(),
            cardMetadataId: 1,
            label: 'Security',
            position: 6,
            type: 'Service List',
            cardData: []
        },
        {
            cardId: uuid(),
            cardMetadataId: 2,
            label: '',
            position: 1,
            type: 'Service Detail',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Contract Size',
                    position: 0,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Service Category',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Service Type',
                    position: 2,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Service Level',
                    position: 3,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Cleaning Hours',
                    position: 4,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Days of Service',
                    position: 5,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Scope of Service',
                    position: 6,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Annual periodic requirements',
                    position: 7,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Special Service',
                    position: 8,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
            ]
        },
        {
            cardId: uuid(),
            cardMetadataId: 3,
            label: '["Interior Data", "Value"]',
            position: 2,
            type: 'Multiple Columns Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Declaration 1',
                    position: 0,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 2',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 3',
                    position: 2,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 4',
                    position: 3,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 5',
                    position: 4,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
            ]
        },
        {
            cardId: uuid(),
            cardMetadataId: 4,
            label: '["Special Notes", "Value"]',
            position: 3,
            type: 'Multiple Columns Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Declaration 1',
                    position: 0,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 2',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 3',
                    position: 2,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 4',
                    position: 3,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 5',
                    position: 4,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
            ]
        },
    ],
    defaultData: [
        {
            cardMetadataId: 1,
            label: '',
            position: 0,
            type: 'Service List',
            cardData: []
        },
        {
            cardMetadataId: 2,
            label: '',
            position: 1,
            type: 'Service Detail',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Contract Size',
                    position: 0,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Service Category',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Service Type',
                    position: 2,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Service Level',
                    position: 3,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Cleaning Hours',
                    position: 4,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Days of Service',
                    position: 5,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Scope of Service',
                    position: 6,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Annual periodic requirements',
                    position: 7,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Special Service',
                    position: 8,
                    type: 'Text',
                    isMandatory: false,
                    isHidden: false,
                    isArchived: false,
                },
            ]
        },
        {
            cardMetadataId: 3,
            label: '["Interior Data", "Value"]',
            position: 2,
            type: 'Multiple Columns Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Declaration 1',
                    position: 0,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 2',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 3',
                    position: 2,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 4',
                    position: 3,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 5',
                    position: 4,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false,
                    isArchived: false,
                },
            ]
        },
        {
            cardMetadataId: 4,
            label: '["Special Notes", "Value"]',
            position: 3,
            type: 'Multiple Columns Data List',
            cardData: [
                {
                    fieldId: uuid(),
                    label: 'Declaration 1',
                    position: 0,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 2',
                    position: 1,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 3',
                    position: 2,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 4',
                    position: 3,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
                {
                    fieldId: uuid(),
                    label: 'Declaration 5',
                    position: 4,
                    type: 'Text',
                    isMandatory: true,
                    isHidden: false
                },
            ]
        },
    ],
}


export const mockDataTab3Layout = {
    data: [
        {
            cardId: uuid(),
            cardMetadataId: 1,
            label: '',
            position: 0,
            type: 'Account Detail',
            cardData: []
        },
        {
            cardId: uuid(),
            cardMetadataId: 2,
            label: 'Conversation History',
            position: 1,
            type: 'Conversation History',
            cardData: []
        },
        {
            cardId: uuid(),
            cardMetadataId: 3,
            label: 'Location List',
            position: 2,
            type: 'Location List',
            cardData: []
        },
        {
            cardId: uuid(),
            cardMetadataId: 4,
            label: 'Life Cycle',
            position: 3,
            type: 'Note',
            cardData: []
        },
    ],
    defaultData: [
        {
            cardMetadataId: 1,
            label: '',
            position: 0,
            type: 'Account Detail',
            cardData: []
        },
        {
            cardMetadataId: 2,
            label: 'Conversation History',
            position: 1,
            type: 'Conversation History',
            cardData: []
        },
        {
            cardMetadataId: 3,
            label: 'Location List',
            position: 2,
            type: 'Location List',
            cardData: []
        },
        {
            cardMetadataId: 4,
            label: 'Life Cycle',
            position: 3,
            type: 'Note',
            cardData: []
        },
    ]
}
